// Page panier /cart (Task 7, revue finale n°2). Depuis le lot 2 « façon Loban », la logique des quantités vit dans le
// module COMMUN assets/moola-quantites.js (page et panier latéral : une seule règle — clé de ligne, file, readOnly et
// jamais `disabled`, « Paiement » différé, repli par l'envoi du formulaire). Ici : la page se recharge quand la file est
// vide (total, résumé et lignes viennent du rendu serveur). Sans JavaScript ou si le module manque, le bouton de repli
// « Mettre à jour » (name="update", updates[<clé>]) reste affiché et fait le travail.
// Ce script est appelé par le gabarit (dans le <main>), donc AVANT les scripts du layout : il attend DOMContentLoaded,
// qui ne part qu'après l'exécution de tous les scripts différés (moola-quantites.js compris).
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('moola-panier');
  if (!form || !window.MoolaQuantites) return;
  const maj = form.querySelector('[data-panier-maj]');
  if (maj) maj.hidden = true;   // JS actif : le bouton de repli n'est plus nécessaire
  window.MoolaQuantites(form, { selecteur: '.qte-input', fin: () => location.reload() });
});
